<!--
제한정책 갱신 버튼 컴포넌트
- 배송등록제한 + 출고제한을 최신 상태로 재판단
-->
<template>
    <button
        type="button"
        class="uk-button uk-button-small uk-button-primary"
        :disabled="loading"
        @click="refresh"
    >
        <i class="material-icons">refresh</i>
        <span v-if="loading">갱신중...</span>
        <span v-else>제한상태 갱신</span>
    </button>
</template>

<script>
    export default {
        props: {
            /**
             * 사용자 ID
             */
            userId: {
                type: [Number, String],
                required: true,
            },

            /**
             * csrf token
             */
            csrfToken: {
                type: String,
                required: true,
            },
        },
        data: function () {
            return {
                loading: false,
            };
        },
        methods: {
            /**
             * 제한정책 갱신 실행
             */
            refresh() {
                if (this.loading) return;
                this.loading = true;

                let opts = {
                    type: 'patch',
                    url: '/company-users/' + this.userId + '/refresh-restrict-policy',
                    data: {
                        '_token': this.csrfToken,
                    },
                    success: (response, textStatus, jqXHR) => {
                        UIkit.modal.alert(response.msg).then(function () {
                            $.app.refresh();
                        });
                    },
                    complete: () => {
                        this.loading = false;
                    },
                };

                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>
